/**
 * 转发目标选择器懒加载壳（21d-3 首屏瘦身；StickerPanelLazy 同构）。
 * 三个调用方（消息菜单转发 / 群二维码分享 / 好友详情分享名片）里，
 * 只有消息菜单那条在首屏块——另外两页本来就是懒块，共用这个壳不影响它们。
 */
import { useLazyModule } from './useLazyModule';
import type { ForwardPickerProps } from './ForwardPicker';

export function ForwardPickerLazy(props: ForwardPickerProps) {
  const { mod } = useLazyModule(() => import('./ForwardPicker'));
  if (mod === null) return null;
  return <mod.ForwardPicker {...props} />;
}
